import * as React from 'react';
import CouponCard from '../CouponCard';
import ReactModal from 'react-modal';
import { MobilePackageType } from '../Frelsi/Types';
import { useRouter } from 'next/router';
import { slug } from '@/pages/frelsi/fylla';
import SuccessModal from './SuccessModal';
import FooterSection from './FooterSection';
import { FrelsiResponse } from '../Frelsi/Utils';

type Props = {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  mobilePackage: MobilePackageType | null;
  setMobilePackage: React.Dispatch<React.SetStateAction<MobilePackageType | null>>;
};

const FyllaFrelsi = ({ showModal, setShowModal, mobilePackage, setMobilePackage }: Props) => {
  const [currentUrl, setCurrentUrl] = React.useState('');
  const [phoneNumber, setPhoneNumber] = React.useState<string | null>(null);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [frelsiResponse, setFrelsiResponse] = React.useState<FrelsiResponse | null>(null);

  const router = useRouter();

  React.useEffect(() => {
    // Remove the parameters that Rapyd adds to the redirect URL
    if (router.asPath.includes('DigitalSignatureResponse=')) {
      router.replace(`/${slug}`, undefined, { shallow: true });
      setShowSuccessModal(true);
    }
    setCurrentUrl(window.location.href);
    ReactModal.setAppElement('body');
  }, [router]);

  const handlePhonenumberChange = (value: string) => {
    if (value === '') {
      return setPhoneNumber(null);
    }
    //Remove non digit characters
    return setPhoneNumber(value.replace(/\D/g, ''));
  };

  const handleOnClose = () => {
    setShowModal(false);
    setMobilePackage(null);
    setFrelsiResponse(null);
  };

  return (
    <>
      <SuccessModal showSuccessModal={showSuccessModal} setShowSuccessModal={setShowSuccessModal} />
      <ReactModal
        isOpen={showModal}
        onRequestClose={() => handleOnClose()}
        contentLabel={'title'}
        htmlOpenClassName="overflow-hidden"
        overlayClassName={'z-20 flex fixed inset-0 justify-center items-center bg-[#000]/20 p-16 lg:p-32'}
        className="relative max-h-full max-w-xl overflow-y-auto rounded-28 outline-none lg:max-w-3xl"
      >
        <CouponCard
          subTitle={mobilePackage ? mobilePackage.subTitle : 'Fylla á'}
          title={mobilePackage ? mobilePackage.label : 'Sýn frelsi'}
          onClose={() => handleOnClose()}
          onPhonenumberChange={(value) => {
            handlePhonenumberChange(value);
            setFrelsiResponse(null);
          }}
          footerSection={
            <FooterSection
              currentUrl={currentUrl}
              phoneNumber={phoneNumber}
              mobilePackage={mobilePackage}
              setFrelsiResponse={setFrelsiResponse}
              frelsiResponse={frelsiResponse}
            />
          }
        />
      </ReactModal>
    </>
  );
};
export default FyllaFrelsi;
